export const dataWithContentType = function dataWithContentType(data) {
  let contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text/plain';
  return contentType.includes('text/plain') ? JSON.stringify(data) : new window.Blob([JSON.stringify(data)], {
    type: 'application/json'
  });
};
const sendBeacon = (url, data, contentType) => navigator.sendBeacon(url, dataWithContentType(data, contentType));
export default sendBeacon;